package songwritersnotebook.app.screens.components

import songwritersnotebook.app.screens.*

import androidx.compose.animation.AnimatedContent
import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.core.animateDpAsState
import androidx.compose.animation.core.tween
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.slideInVertically
import androidx.compose.animation.slideOutVertically
import androidx.compose.animation.togetherWith
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.Canvas
import androidx.compose.foundation.ScrollState
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.gestures.awaitEachGesture
import androidx.compose.foundation.gestures.calculateCentroid
import androidx.compose.foundation.gestures.detectDragGestures
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.gestures.detectVerticalDragGestures
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.ArrowBack
import androidx.compose.material.icons.filled.Add
import androidx.compose.material.icons.filled.AutoFixNormal
import androidx.compose.material.icons.filled.Check
import androidx.compose.material.icons.filled.ChevronLeft
import androidx.compose.material.icons.filled.ChevronRight
import androidx.compose.material.icons.filled.Close
import androidx.compose.material.icons.filled.ContentCopy
import androidx.compose.material.icons.filled.Delete
import androidx.compose.material.icons.filled.Edit
import androidx.compose.material.icons.filled.ExpandLess
import androidx.compose.material.icons.filled.ExpandMore
import androidx.compose.material.icons.filled.Info
import androidx.compose.material.icons.filled.Lock
import androidx.compose.material.icons.filled.MusicNote
import androidx.compose.material.icons.filled.Pause
import androidx.compose.material.icons.filled.PlayArrow
import androidx.compose.material.icons.filled.Redo
import androidx.compose.material.icons.filled.Settings
import androidx.compose.material.icons.filled.Undo
import androidx.compose.material3.*
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.material.icons.filled.Piano
import androidx.compose.material.icons.filled.Remove
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.scale
import androidx.compose.ui.geometry.CornerRadius
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Path
import androidx.compose.ui.graphics.PathEffect
import androidx.compose.ui.graphics.StrokeCap
import androidx.compose.ui.graphics.drawscope.DrawScope
import androidx.compose.ui.graphics.drawscope.Stroke
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.layout.LayoutCoordinates
import androidx.compose.ui.layout.boundsInWindow
import androidx.compose.ui.layout.onGloballyPositioned
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.unit.times
import songwritersnotebook.app.components.ChordPanel
import songwritersnotebook.app.components.ChordCreatorSheet
import songwritersnotebook.app.components.SaveStatusIndicator
import songwritersnotebook.app.components.StudioSettingsDialog
import songwritersnotebook.app.data.Song
import songwritersnotebook.app.data.Track
import songwritersnotebook.app.data.TrackData
import songwritersnotebook.app.data.TrackItem
import songwritersnotebook.app.ui.theme.BlueAccent
import songwritersnotebook.app.ui.theme.GoldAccent
import songwritersnotebook.app.utils.ChordUtils
import songwritersnotebook.app.viewmodels.DragType
import songwritersnotebook.app.viewmodels.GuitarInputMode
import songwritersnotebook.app.viewmodels.StepInterval
import songwritersnotebook.app.viewmodels.StepIntervalType
import songwritersnotebook.app.viewmodels.StudioUiState
import songwritersnotebook.app.viewmodels.StudioViewModel
import songwritersnotebook.app.tutorial.TutorialManager
import songwritersnotebook.app.tutorial.TutorialStep
import songwritersnotebook.app.tutorial.tutorialTarget
import kotlinx.coroutines.launch
import kotlinx.coroutines.delay
import org.jetbrains.compose.resources.painterResource
import androidx.compose.ui.text.drawText
import androidx.compose.ui.text.rememberTextMeasurer
import songwritersnotebookapp.composeapp.generated.resources.Res
import songwritersnotebookapp.composeapp.generated.resources.ic_guitar
import songwritersnotebookapp.composeapp.generated.resources.ic_rewind
import songwritersnotebookapp.composeapp.generated.resources.ic_bass
import songwritersnotebookapp.composeapp.generated.resources.ic_drum
import com.benasher44.uuid.uuid4
import kotlin.math.abs
import kotlin.math.max
import kotlin.math.roundToInt


@Composable
fun TrackSettingsMenu(
    track: Track,
    onMuteChange: (Boolean) -> Unit,
    onSoloChange: (Boolean) -> Unit,
    onVolumeChange: (Float) -> Unit,
    onStrumSpeedChange: (Float) -> Unit,
    onDismiss: () -> Unit
) {
    DropdownMenu(expanded = true, onDismissRequest = onDismiss) {
        DropdownMenuItem(
            text = { Text(if (track.isMuted) "Unmute" else "Mute") },
            onClick = { onMuteChange(!track.isMuted) }
        )
        DropdownMenuItem(
            text = { Text(if (track.isSoloed) "Unsolo" else "Solo") },
            onClick = { onSoloChange(!track.isSoloed) }
        )
        HorizontalDivider()
        
        Column(modifier = Modifier.padding(horizontal = 12.dp, vertical = 8.dp)) {
            var isVolumeDragging by remember { mutableStateOf(false) }
            var localVolume by remember(track.id) { mutableStateOf(track.volume) }
            
            LaunchedEffect(track.volume) {
                if (!isVolumeDragging) localVolume = track.volume
            }

            Text("Volume: ${(localVolume * 100).toInt()}%", style = MaterialTheme.typography.bodySmall)
            Slider(
                value = localVolume,
                onValueChange = { 
                    isVolumeDragging = true
                    localVolume = it
                    onVolumeChange(it) 
                },
                onValueChangeFinished = { isVolumeDragging = false },
                valueRange = 0f..4f
            )
        }
        // Show strum speed for chord instruments
        if (track.name.lowercase().contains("guitar") || track.name.lowercase().contains("piano")) {
             Column(modifier = Modifier.padding(horizontal = 12.dp, vertical = 8.dp)) {
                var isStrumDragging by remember { mutableStateOf(false) }
                var localStrum by remember(track.id) { mutableStateOf(track.strumSpeed) }
                
                LaunchedEffect(track.strumSpeed) {
                    if (!isStrumDragging) localStrum = track.strumSpeed
                }

                Text("Strum Speed", style = MaterialTheme.typography.bodySmall)
                Slider(
                    value = localStrum,
                    onValueChange = {
                        isStrumDragging = true
                        localStrum = it
                        onStrumSpeedChange(it)
                    },
                    onValueChangeFinished = { isStrumDragging = false },
                    valueRange = 0f..1f
                )
            }
        }
    }
}


@Composable
fun IntervalSliderDialog(
    initialInterval: StepInterval,
    label: String,
    onDismiss: () -> Unit,
    onSave: (StepInterval) -> Unit
) {
    var localInterval by remember { mutableStateOf(initialInterval) }
    var localNumerator by remember { mutableStateOf(initialInterval.numerator.toString()) }
    var localDenominator by remember { mutableStateOf(initialInterval.denominator.toString()) }

    fun safeToInt(s: String, fallback: Int): Int {
        return s.filter { it.isDigit() }.toIntOrNull() ?: fallback
    }

    AlertDialog(
        onDismissRequest = onDismiss,
        confirmButton = { 
            Button(
                onClick = { onSave(localInterval) },
                enabled = localInterval.denominator > 0 && localInterval.numerator > 0
            ) { Text("OK") } 
        },
        dismissButton = { TextButton(onClick = onDismiss) { Text("Cancel") } },
        title = { Text(label) },
        text = {
            Column(modifier = Modifier.fillMaxWidth().padding(vertical = 8.dp)) {
                Row(modifier = Modifier.fillMaxWidth()) {
                    val isBar = localInterval.base == "bar"
                    OutlinedButton(
                        onClick = { localInterval = localInterval.copy(base = "bar") },
                        modifier = Modifier.weight(1f),
                        colors = if (isBar) ButtonDefaults.buttonColors() else ButtonDefaults.outlinedButtonColors()
                    ) { Text("Bar") }
                    Spacer(Modifier.width(8.dp))
                    OutlinedButton(
                        onClick = { localInterval = localInterval.copy(base = "beat") },
                        modifier = Modifier.weight(1f),
                        colors = if (!isBar) ButtonDefaults.buttonColors() else ButtonDefaults.outlinedButtonColors()
                    ) { Text("Beat") }
                }
                Spacer(modifier = Modifier.height(16.dp))
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.Center
                ) {
                    OutlinedTextField(
                        value = localNumerator,
                        onValueChange = { 
                            localNumerator = it 
                            val num = safeToInt(it, 1)
                            localInterval = localInterval.copy(numerator = num)
                        },
                        modifier = Modifier.width(70.dp),
                        textStyle = LocalTextStyle.current.copy(textAlign = androidx.compose.ui.text.style.TextAlign.Center),
                        keyboardOptions = androidx.compose.foundation.text.KeyboardOptions(keyboardType = androidx.compose.ui.text.input.KeyboardType.Number),
                        singleLine = true
                    )
                    Text("/", modifier = Modifier.padding(horizontal = 8.dp), style = MaterialTheme.typography.titleLarge)
                    OutlinedTextField(
                        value = localDenominator,
                        onValueChange = { 
                            localDenominator = it 
                            val den = safeToInt(it, 1)
                            localInterval = localInterval.copy(denominator = den)
                        },
                        modifier = Modifier.width(70.dp),
                        textStyle = LocalTextStyle.current.copy(textAlign = androidx.compose.ui.text.style.TextAlign.Center),
                        keyboardOptions = androidx.compose.foundation.text.KeyboardOptions(keyboardType = androidx.compose.ui.text.input.KeyboardType.Number),
                        singleLine = true
                    )
                }
            }
        }
    )
}

